const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/users/$userId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/users/$userId')({
  staticData: {
    breadCrumb: 'User Detail'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});